import React from 'react'

const BoxItem3 = (props) => {
    const {title, number} = props

    return <div className="BoxItem">
        <div className="d-flex justify-content-between">
            <div className="Title">
                <div className="Name">{title}</div>
                <div className="Number">{number ? `${number} VNĐ` : 'N/A'}</div>
            </div>
        </div>
    </div>
}

export default BoxItem3
